import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { usePosts } from "../contexts/PostContext";
import BoardDetail from "../components/BoardDetail";

export default function BoardDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { posts, loadPosts } = usePosts();
 
  
// posts가 비어 있으면 자동으로 fetch/load
  useEffect(() => {
    if (!posts.length) {
      // board_type은 실제 게시판 타입에 맞게!
      loadPosts("Free-Talk"); // 또는 "공동게시판", "freetalk" 등 DB에 맞게
    }
  }, [posts, loadPosts]);

  if (!posts.length) {
    return (
      <div className="text-center py-24 text-lg text-gray-400">
        게시글을 불러오는 중입니다...
      </div>
    );
  }

  const post = posts.find((p) => String(p.id) === String(id));

  if (!post) {
    return (
      <div className="text-center py-24 text-lg text-gray-400">
        존재하지 않는 게시글입니다.
      </div>
    );
  }

  return (
    <BoardDetail
      post={post}
      onClose={() => navigate(-1)}
      onRecommend={() => {}}
      boardRoute="/board"
    />
  );
}
